import { isUndefined } from 'lodash';

export function ancestorHasClass(el: any, className: string) {
  if (isUndefined(el.className) || !el.className.split) {
    return false;
  }

  if (el.className.split(' ').indexOf(className) >= 0) {
    return true;
  }

  return el.parentNode && ancestorHasClass(el.parentNode, className);
}
